import { render, staticRenderFns } from "./SlideWithThumbs.vue?vue&type=template&id=78d136b8&scoped=true&lang=pug&"
import script from "./SlideWithThumbs.vue?vue&type=script&lang=js&"
export * from "./SlideWithThumbs.vue?vue&type=script&lang=js&"
import style0 from "./SlideWithThumbs.vue?vue&type=style&index=0&id=78d136b8&lang=scss&scoped=true&"
import style1 from "./SlideWithThumbs.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d136b8",
  null
  
)

export default component.exports